export const categories = [
  { slug: 'dresses', name: '连衣裙', icon: 'ri-shirt-line' },
  { slug: 'tops', name: '上衣', icon: 'ri-t-shirt-line' },
  { slug: 'pants', name: '裤装', icon: 'ri-briefcase-4-line' },
  { slug: 'skirts', name: '半身裙', icon: 'ri-women-line' },
  { slug: 'outerwear', name: '外套', icon: 'ri-sun-line' },
  { slug: 'accessories', name: '配饰', icon: 'ri-handbag-line' },
  { slug: 'shoes', name: '鞋履', icon: 'ri-footprint-line' },
  { slug: 'beauty', name: '美妆', icon: 'ri-magic-line' },
];

export const heroSlides = [
  {
    title: '2026 秋季新品首发',
    subtitle: '邂逅秋日浪漫，焕新你的衣橱',
    cta: '立即探索',
    link: '/category/dresses',
  },
  {
    title: '限时特惠 · 低至3折',
    subtitle: '精选千款时尚单品，焕新不等待',
    cta: '抢购好物',
    link: '/category/tops',
  },
];

export const featuredProducts = [
  {
    id: 'p1',
    name: '法式复古碎花连衣裙',
    price: 299,
    originalPrice: 599,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20floral%20print%20midi%20dress%20in%20soft%20beige%20and%20rose%20tones%2C%20french%20vintage%20style%2C%20clean%20cream%20background%2C%20fashion%20product%20photography%20with%20soft%20natural%20lighting%2C%20minimalist%20studio%20setup%2C%20delicate%20fabric%20texture%20visible%2C%20editorial%20quality&width=600&height=800&seq=product-dress-01&orientation=portrait',
    tag: '热卖',
    category: 'dresses',
  },
  {
    id: 'p2',
    name: '简约纯色宽松衬衫',
    price: 189,
    originalPrice: 359,
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20white%20oversized%20button%20down%20shirt%20for%20women%2C%20clean%20cream%20studio%20background%2C%20soft%20natural%20lighting%2C%20fashion%20product%20photography%2C%20elegant%20casual%20style%2C%20subtle%20fabric%20details%2C%20editorial%20quality&width=600&height=800&seq=product-shirt-02&orientation=portrait',
    tag: '新品',
    category: 'tops',
  },
  {
    id: 'p3',
    name: '高腰直筒西装裤',
    price: 259,
    originalPrice: 459,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20high%20waisted%20straight%20leg%20trousers%20in%20warm%20beige%20tone%2C%20tailored%20fabric%2C%20clean%20cream%20studio%20background%2C%20soft%20lighting%2C%20fashion%20product%20photography%2C%20minimalist%20professional%20style%2C%20editorial%20quality&width=600&height=800&seq=product-pants-03&orientation=portrait',
    tag: '热卖',
    category: 'pants',
  },
  {
    id: 'p4',
    name: '轻薄针织开衫外套',
    price: 329,
    originalPrice: 529,
    image: 'https://readdy.ai/api/search-image?query=Soft%20lightweight%20knit%20cardigan%20in%20warm%20camel%20tone%2C%20cozy%20texture%2C%20clean%20cream%20studio%20background%2C%20soft%20natural%20lighting%2C%20fashion%20product%20photography%2C%20elegant%20minimalist%20style%2C%20editorial%20quality&width=600&height=800&seq=product-cardigan-04&orientation=portrait',
    tag: '新品',
    category: 'outerwear',
  },
  {
    id: 'p5',
    name: 'A字百褶中长裙',
    price: 219,
    originalPrice: 389,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20a-line%20pleated%20midi%20skirt%20in%20soft%20dusty%20rose%20color%2C%20flowing%20fabric%2C%20clean%20cream%20studio%20background%2C%20soft%20lighting%2C%20fashion%20product%20photography%2C%20feminine%20minimalist%20style%2C%20editorial%20quality&width=600&height=800&seq=product-skirt-05&orientation=portrait',
    tag: '热卖',
    category: 'skirts',
  },
  {
    id: 'p6',
    name: '真皮简约手提包',
    price: 459,
    originalPrice: 799,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20leather%20tote%20bag%20in%20warm%20cognac%20brown%2C%20clean%20cream%20studio%20background%2C%20soft%20natural%20lighting%2C%20fashion%20accessory%20photography%2C%20premium%20texture%2C%20editorial%20quality&width=600&height=800&seq=product-bag-06&orientation=portrait',
    tag: '精品',
    category: 'accessories',
  },
  {
    id: 'p7',
    name: '尖头细跟通勤单鞋',
    price: 339,
    originalPrice: 569,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20pointed%20toe%20kitten%20heel%20pumps%20in%20warm%20nude%20tone%2C%20clean%20cream%20studio%20background%2C%20soft%20lighting%2C%20fashion%20shoe%20photography%2C%20minimalist%20professional%20style%2C%20editorial%20quality&width=600&height=800&seq=product-shoes-07&orientation=portrait',
    tag: '热卖',
    category: 'shoes',
  },
  {
    id: 'p8',
    name: '丝绒哑光口红礼盒',
    price: 169,
    originalPrice: 299,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20velvet%20matte%20lipstick%20set%20in%20warm%20rose%20tones%2C%20clean%20cream%20studio%20background%2C%20soft%20lighting%2C%20beauty%20product%20photography%2C%20minimalist%20luxury%20style%2C%20editorial%20quality&width=600&height=800&seq=product-lipstick-08&orientation=portrait',
    tag: '新品',
    category: 'beauty',
  },
];

export const trendingArticles = [
  {
    slug: 'autumn-2026-trends',
    title: '2026秋季穿搭趋势：温柔与力量并存',
    excerpt: '本季以柔和的轮廓与大胆的配色相融合，复古元素与现代剪裁碰撞出全新的时尚语言。从秀场到街头，带你掌握这一季的穿搭密码。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20autumn%20fashion%20editorial%20with%20warm%20toned%20clothing%20in%20camel%20and%20burgundy%2C%20soft%20natural%20lighting%2C%20minimalist%20studio%20setup%2C%20fashion%20magazine%20style%20photography%2C%20cozy%20textures%20and%20layered%20looks&width=800&height=500&seq=article-autumn-01&orientation=landscape',
    date: '2026-08-05',
    author: '蘑菇编辑部',
    category: '穿搭',
  },
  {
    slug: 'capsule-wardrobe-guide',
    title: '极简衣橱指南：30件单品穿出100种风格',
    excerpt: '学会胶囊衣橱法则，用最少的单品创造最多的搭配可能。从基础款到点睛配饰，打造属于你的高效衣橱。',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20capsule%20wardrobe%20display%20with%20neutral%20toned%20clothing%20items%20arranged%20neatly%2C%20warm%20beige%20and%20cream%20colors%2C%20clean%20studio%20background%2C%20soft%20lighting%2C%20fashion%20editorial%20photography%2C%20organized%20minimal%20aesthetic&width=800&height=500&seq=article-capsule-02&orientation=landscape',
    date: '2026-07-28',
    author: '蘑菇编辑部',
    category: '穿搭',
  },
  {
    slug: 'skincare-routine-autumn',
    title: '换季护肤全攻略：让你的肌肤喝饱水',
    excerpt: '夏秋交替时节，肌肤容易出现干燥、敏感等问题。资深美容编辑为你整理了一套科学有效的换季护肤方案。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20skincare%20products%20arranged%20on%20marble%20surface%20with%20natural%20botanical%20elements%2C%20warm%20soft%20lighting%2C%20clean%20aesthetic%2C%20beauty%20editorial%20photography%2C%20minimalist%20luxury%20style%2C%20cream%20and%20glass%20bottles&width=800&height=500&seq=article-skincare-03&orientation=landscape',
    date: '2026-07-20',
    author: '蘑菇编辑部',
    category: '美妆',
  },
];

export const promotions = [
  {
    title: '新人专享',
    subtitle: '首单立减 ¥50',
    icon: 'ri-gift-line',
  },
  {
    title: '满299包邮',
    subtitle: '全国顺丰直达',
    icon: 'ri-truck-line',
  },
  {
    title: '7天无忧退换',
    subtitle: '不满意随时退',
    icon: 'ri-refresh-line',
  },
  {
    title: '会员专属折扣',
    subtitle: '积分当钱花',
    icon: 'ri-vip-crown-line',
  },
];